
angular.module('mtic.components.login', [
      'mtic.components.alert_popup'
])

angular.module('mtic.components.login').directive('login', function (EventManager, userAccount) {
      return {
            templateUrl: 'template.html',
            scope: {},
            link: function (scope) {
                  var eventManager = new EventManager('login', scope)
                  scope.type = 'signin';
                  scope.username = userAccount.getData().uuid;
                  scope.restoringSession = false;
                  eventManager.listen('login:open', function (e, type) {
                        scope.type = type;
                  })
            }
      }
})
